import Axios from 'axios';
import Image from 'next/image';
import Link from 'next/link';
import React, {useEffect, useState, useMemo} from 'react';

export default function NoticePopupBanner(props) {

  const [isBannerVisible, setIsBannerVisible] = useState(true);

  const handleClose = (e) => {
    e.preventDefault();
    setIsBannerVisible(false);
  };

  useEffect(() => {
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);

  // ✅ 링크 변환 로직
  const convertedLink = useMemo(() => {
    const originalUrl = props?.data?.[0]?.link_url;

    if (!originalUrl) return '#';

    try {
      const url = new URL(originalUrl);
      const boardNo = url.searchParams.get('board_no');

      if (boardNo) {
        return `https://www.sbs.co.kr/m/main/notice.html?div=footer_m&cmd=view&page=1&board_no=${boardNo}`;
      }

      return originalUrl;
    } catch (e) {
      console.error('URL 파싱 오류:', e);
      return originalUrl;
    }
  }, [props]);

  // 로그
  const handleClick_custom = () => {
    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '팝업공지',
        clickType: 'NC',
        value1: props.data[0].notice_title,
        value2: '',
        value3: '',
        value4: '',
        value5: ''
      }
    });
  };

  return (
      <>
        {isBannerVisible && (
            <div className="noticeBannerLayer_w current">
              <div className="noticeBannerLayer_inner">
                <div className="noticeBannerLayerTitle">
                  <span className="iconSvg_emergency"></span>
                  <p className="noticeTopBanner-text">

                    {/* ✅ 변환된 링크 사용 */}
                    <Link href={convertedLink}>
                      <a onClick={handleClick_custom}>
                        {props.data[0].notice_title}
                      </a>
                    </Link>

                  </p>
                </div>

                <div className="noticeBannerLayer_content">
                  <div className="noticeBannerLayer_cont">
                    {props.data[0].notice_content}
                  </div>
                </div>

                <button
                    type="button"
                    className="btn_noticeClosed"
                    onClick={handleClose}
                >
              <span className="iconSvg_closed">
                <i className="hide">닫기</i>
              </span>
                </button>
              </div>
            </div>
        )}
      </>
  );
}